var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { maxStudyAdditionalSections } from "healthex-common/constants";
import { ProjectPageName, ProjectSectionName, ProjectStaticPageName, } from "healthex-common/project.data.dtos";
import { sectionDisplayNames, StudyPeriodicDayAndWeekUnits, StudyStatus, StudyTranslationLanguage, } from "healthex-common/study.dtos";
import { willNeverHappen } from "healthex-common/utils";
import { computed, observable } from "mobx";
import { getObservableT } from "../../Infra/i18next";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { SimpleDialogModel } from "../SimpleDialogModel";
import { drawerStore } from "../SimpleDrawerModel";
import { viewOnlyTextDefaults } from "../viewOnlyTextDefaults";
const t = getObservableT("project");
export class AddProjectViewModel {
    constructor(container) {
        this.predefinedDisplayNames = Object.values(sectionDisplayNames);
        this.teamMembersDialog = new SimpleDialogModel();
        this.learnMoreDialog = new SimpleDialogModel();
        this.addSectionDialog = new SimpleDialogModel();
        this.confirmDiscardDialog = new SimpleDialogModel();
        this.disposers = [];
        this.icfDrawer = drawerStore;
        this.addSectionTitle = null;
        this.protocolType = null;
        this.protocolDocumentUrl = null;
        this.studyToImport = null;
        this.addAdditionalSection = async (imageId) => {
            var _a, _b, _c, _d, _e;
            const confirmed = await this.addSectionDialog.showAndWait();
            if (!confirmed) {
                this.closeAddSectionDialog(false);
                return;
            }
            try {
                this.formModel.updateInput({
                    additionalSections: [
                        ...((_a = this.formModel.input.additionalSections) !== null && _a !== void 0 ? _a : []),
                        {
                            id: `temp_${crypto.randomUUID()}`,
                            title: (_b = this.addSectionTitle) !== null && _b !== void 0 ? _b : "",
                            description: "",
                            included: true,
                            language: StudyTranslationLanguage.en,
                        },
                    ],
                });
                await this.refreshStudy();
                await new Promise((resolve) => setTimeout(resolve, 1000));
                let additionalSection = (_c = this.studyAdditionalSections) === null || _c === void 0 ? void 0 : _c.find((section) => section.title === this.addSectionTitle);
                if (!additionalSection) {
                    additionalSection = (_d = this.studyAdditionalSections) === null || _d === void 0 ? void 0 : _d[((_e = this.studyAdditionalSections) === null || _e === void 0 ? void 0 : _e.length) - 1];
                }
                if (additionalSection && imageId) {
                    await this.handleMove(imageId, ProjectPageName.PATIENT_EXPERIENCE, ProjectSectionName.ADDITIONAL_INFORMATION, additionalSection.id);
                }
            }
            catch (error) {
                console.error("Error adding additional section:", error);
            }
            this.closeAddSectionDialog(true);
        };
        this.closeAddSectionDialog = (choice) => {
            this.addSectionDialog.open = false;
            this.addSectionTitle = null;
        };
        this.updateAddSectionTitle = (title) => {
            this.addSectionTitle = title;
        };
        this.appUIManager = container.appUIManager;
        this.addProjectRequirementsWizardUIManager = container.addProjectRequirementsWizardUIManager;
        this.addProjectUIManager = container.addProjectUIManager;
    }
    run() { }
    stop() {
        this.disposers.forEach((disposer) => disposer());
        this.disposers = [];
    }
    get viewOnlyTextDefaults() {
        const defaults = {};
        Object.entries(viewOnlyTextDefaults(StudyTranslationLanguage.en)).forEach(([key, value]) => {
            const assertedKey = key;
            if (typeof value === "function") {
                if (this.orgName) {
                    defaults[assertedKey] = value(this.orgName);
                }
            }
            else {
                defaults[assertedKey] = value;
            }
        });
        return defaults;
    }
    get projectPages() {
        return this.addProjectUIManager.projectPages;
    }
    get formModel() {
        return this.addProjectUIManager.studyFormModel;
    }
    get aiGeneratedFieldsModel() {
        return this.addProjectUIManager.aiGeneratedFieldsModel;
    }
    get study() {
        return this.addProjectUIManager.study;
    }
    get studyAddedByOrganization() {
        if (this.study === NOT_LOADED || !this.study)
            return null;
        return this.study.addedByOrganization;
    }
    get orgName() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.addedByOrganization.name;
    }
    get isSponsoredStudy() {
        return this.addProjectUIManager.isSponsoredStudy;
    }
    get isInterventionalStudy() {
        return this.addProjectUIManager.isInterventionalStudy;
    }
    get needsIdentifiedData() {
        return this.addProjectUIManager.needsIdentifiedData;
    }
    get studyProtocolFileName() {
        var _a;
        if (this.study === NOT_LOADED || !((_a = this.study) === null || _a === void 0 ? void 0 : _a.studyProtocolFileName))
            return null;
        return this.study.studyProtocolFileName;
    }
    get icfProtocolFileName() {
        var _a;
        if (this.study === NOT_LOADED || !((_a = this.study) === null || _a === void 0 ? void 0 : _a.icfFileName))
            return null;
        return this.study.icfFileName;
    }
    get myStudyUser() {
        return this.addProjectUIManager.myStudyUser;
    }
    get currentPage() {
        return this.addProjectUIManager.currentPage;
    }
    get currentProjectPage() {
        return this.addProjectUIManager.currentProjectPage;
    }
    get pageTitle() {
        var _a, _b;
        return (_b = (_a = this.currentProjectPage) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : "";
    }
    get pageDescription() {
        var _a, _b;
        return (_b = (_a = this.currentProjectPage) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : "";
    }
    get showBackButton() {
        return this.addProjectUIManager.currentPage !== ProjectPageName.PROJECT_DETAILS;
    }
    get topBannerInfo() {
        if (this.study === NOT_LOADED || !this.study)
            return null;
        return null;
    }
    get nextButtonText() {
        return "Next";
    }
    get nextButtonEnabled() {
        return true;
    }
    get showNextButton() {
        return this.currentPage !== ProjectStaticPageName.PREVIEW;
    }
    get showSkipButton() {
        return this.currentPage === ProjectStaticPageName.TRANSLATIONS;
    }
    get addProjectDialogTitleInfo() {
        return this.addProjectRequirementsWizardUIManager.dialogTitleInfo;
    }
    get informedConsentLockedDialogModel() {
        return this.addProjectUIManager.informedConsentLockedDialogModel;
    }
    get majorChangesDialogModel() {
        return this.addProjectUIManager.majorChangesDialogModel;
    }
    get majorChangesDialogTitle() {
        switch (this.majorChangesDialogModel.changesType) {
            case "COMPLETED_ADDING":
                return "Another team member completed the process of adding the project";
            case "ICF_UPLOADED":
                return "A team member imported an informed consent document";
            case "NEW_ICF_UPLOADED":
                return "A team member imported a different informed consent document";
            case null:
                return "";
        }
        return willNeverHappen(this.majorChangesDialogModel.changesType);
    }
    get majorChangesDialogText() {
        switch (this.majorChangesDialogModel.changesType) {
            case "COMPLETED_ADDING":
                return "Since another team member completed adding this project to HealthEx, you can no longer make changes. Please continue to the Project Manager to assist with managing with the project.";
            case "ICF_UPLOADED":
                return "Another team member imported an existing informed consent document to fill in some of the details in this section. This will override some of the information you’ve entered. Reload the project to continue. Some information may be lost or newly required.";
            case "NEW_ICF_UPLOADED":
                return "Another team member imported a different informed consent document to fill in some of the details in this section. This will override some of the information you’ve entered. Reload the project to continue. Some information may be lost or newly required.";
            case null:
                return null;
        }
        return willNeverHappen(this.majorChangesDialogModel.changesType);
    }
    get showMinorParticipantConsent() {
        if (this.study === NOT_LOADED || !this.study)
            return false;
        return this.formModel.input.minorParticipantConsentEnabled;
    }
    get studyId() {
        if (this.study === NOT_LOADED || !this.study)
            return null;
        return this.addProjectUIManager.studyId;
    }
    get orgId() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.addedByOrganization.id;
    }
    get studyAdditionalSections() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.additionalSections;
    }
    get studySectionImages() {
        if (this.study === NOT_LOADED || this.study === null)
            return null;
        return this.study.studySectionImages;
    }
    get getSectionImages() {
        return (sectionName, language = StudyTranslationLanguage.en, additionalSectionId) => {
            var _a;
            if (this.study === NOT_LOADED || this.study === null)
                return null;
            const images = (_a = this.study.studySectionImages) === null || _a === void 0 ? void 0 : _a.find((section) => section.sectionName === sectionName);
            if (sectionName.startsWith("ADDITIONAL_INFORMATION") && additionalSectionId) {
                let filteredImages = images === null || images === void 0 ? void 0 : images.images.filter((img) => img.additionalSectionId === additionalSectionId && img.language === language);
                if (language !== StudyTranslationLanguage.en && filteredImages) {
                    filteredImages = filteredImages.map((img) => {
                        var _a;
                        return {
                            ...img,
                            imageUrl: img.imageUrl ||
                                (img.translatedFrom ? (_a = images === null || images === void 0 ? void 0 : images.images.find((pic) => pic.id === img.translatedFrom)) === null || _a === void 0 ? void 0 : _a.imageUrl : null) ||
                                "",
                        };
                    });
                }
                return filteredImages;
            }
            let filteredImages = images === null || images === void 0 ? void 0 : images.images.filter((img) => !img.additionalSectionId && img.language === language);
            if (language !== StudyTranslationLanguage.en && filteredImages) {
                filteredImages = filteredImages.map((img) => {
                    var _a;
                    return {
                        ...img,
                        imageUrl: img.imageUrl ||
                            (img.translatedFrom ? (_a = images === null || images === void 0 ? void 0 : images.images.find((pic) => pic.id === img.translatedFrom)) === null || _a === void 0 ? void 0 : _a.imageUrl : null) ||
                            "",
                    };
                });
            }
            return filteredImages;
        };
    }
    get getSectionImagesCount() {
        return (sectionName, language = StudyTranslationLanguage.en, additionalSectionId) => {
            var _a, _b;
            return (_b = (_a = this.getSectionImages(sectionName, language, additionalSectionId)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        };
    }
    get getAdditionalSectionImages() {
        return (sectionName, language = StudyTranslationLanguage.en, additionalSectionId) => {
            var _a;
            if (this.study === NOT_LOADED || this.study === null)
                return null;
            return (_a = this.study.studySectionImages) === null || _a === void 0 ? void 0 : _a.find((section) => {
                return (section.sectionName === sectionName &&
                    section.images.find((image) => image.additionalSectionId === additionalSectionId && image.language === language));
            });
        };
    }
    get getComponentKey() {
        return (sectionName, language = StudyTranslationLanguage.en, additionalSectionId, additionalSectionIndex) => {
            return additionalSectionIndex
                ? `${sectionName}-${additionalSectionIndex}-${this.getSectionImagesCount(sectionName, language, additionalSectionId)}`
                : `${sectionName}-${this.getSectionImagesCount(sectionName, language, additionalSectionId)}`;
        };
    }
    async refreshStudy() {
        await this.addProjectUIManager.refreshStudy();
    }
    get pdda() {
        if (this.study === NOT_LOADED || this.study === null)
            return false;
        return this.study.pdda;
    }
    get topBannerHeight() {
        return this.addProjectUIManager.topBannerHeight;
    }
    get currentPageLoading() {
        return this.addProjectUIManager.currentPageLoading;
    }
    get hasReachedMaxAdditionalSections() {
        var _a, _b;
        return ((_b = (_a = this.studyAdditionalSections) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) >= maxStudyAdditionalSections;
    }
    addTeamMembers() {
        void (async () => {
            await this.teamMembersDialog.showAndWait();
            await this.addProjectUIManager.refreshStudy({ fullRefresh: true });
        })();
    }
    get showShareButton() {
        var _a;
        return this.study !== NOT_LOADED && ((_a = this.study) === null || _a === void 0 ? void 0 : _a.status) === StudyStatus.DRAFT;
    }
    get showDiscardChangesButton() {
        var _a;
        return this.study !== NOT_LOADED && ((_a = this.study) === null || _a === void 0 ? void 0 : _a.status) !== StudyStatus.DRAFT;
    }
    get saveAndExitButtonText() {
        var _a;
        return this.study !== NOT_LOADED && ((_a = this.study) === null || _a === void 0 ? void 0 : _a.status) === StudyStatus.DRAFT ? "Save & exit" : "Save draft & exit";
    }
    async discardChanges() {
        const confirmed = await this.confirmDiscardDialog.showAndWait();
        if (confirmed) {
            await this.addProjectUIManager.deleteStudyDraft();
        }
    }
    async saveAndExit() {
        await this.addProjectUIManager.saveAndExit();
    }
    async goToPreviousPage() {
        await this.addProjectUIManager.goToPreviousPage();
    }
    async goToNextPage() {
        await this.addProjectUIManager.goToNextPage();
    }
    async skipPage() {
        await this.addProjectUIManager.goToNextPage();
    }
    navigateToHome() {
        const homepage = this.appUIManager.homepage;
        if (homepage === null)
            return;
        this.appUIManager.navigateToPage(homepage);
    }
    closeProtocolDocumentDownloadUrl() {
        this.protocolDocumentUrl = null;
    }
    updateStudWithPatientFacingDetails(patientFacingDetails) {
        void this.addProjectUIManager.updateStudyWithUploadedICFData(patientFacingDetails);
    }
    deletePrimaryDiseaseOrCondition(index) {
        if (this.formModel.input.primaryDiseaseOrConditions.length === 1) {
            this.formModel.input.primaryDiseaseOrConditions[0] = "";
        }
        else {
            this.formModel.input.primaryDiseaseOrConditions.splice(index, 1);
        }
        this.formModel.updateInput({
            primaryDiseaseOrConditions: this.formModel.input.primaryDiseaseOrConditions,
        });
    }
    deleteIntervention(index) {
        if (this.formModel.input.interventions.length === 1) {
            this.formModel.input.interventions[0] = "";
        }
        else {
            this.formModel.input.interventions.splice(index, 1);
        }
        this.formModel.updateInput({
            interventions: this.formModel.input.interventions,
        });
    }
    updateStudy(patientFacingDetails) {
        void this.addProjectUIManager.updateStudyWithUploadedICFData(patientFacingDetails);
    }
    showLearnMoreDialog() {
        this.learnMoreDialog.open = true;
    }
    deleteTimeline(index) {
        if (!this.formModel.input.timelineVisits)
            return;
        if (this.formModel.input.timelineVisits.length === 1) {
            this.formModel.input.timelineVisits[0] = { period: "", description: "" };
        }
        else {
            this.formModel.input.timelineVisits.splice(index, 1);
        }
        this.formModel.updateInput({
            timelineVisits: this.formModel.input.timelineVisits,
        });
    }
    async updateVisitedSections(inViewSectionName) {
        await this.addProjectUIManager.updateVisitedSections([inViewSectionName], true);
    }
    updateTopBannerHeight(height) {
        this.addProjectUIManager.updateTopBannerHeight(height);
    }
    updateLastSectionOffset(offset) {
        this.addProjectUIManager.updateLastSectionOffset(offset);
    }
    get bottomPaddingForPage() {
        return this.addProjectUIManager.bottomPaddingForPage;
    }
    getSubsectionFooterText(footerText) {
        var _a;
        if (!footerText)
            return null;
        switch (footerText) {
            case "continueAccessingRecords":
                return this.formModel.input.healthRecordsUpdatesOnDemand
                    ? null
                    : t("continueAccessingRecords", {
                        frequency: (_a = this.getHealthRecordsUpdateFrequencyUnitText()) !== null && _a !== void 0 ? _a : "",
                        orgName: this.orgName,
                    });
        }
        return willNeverHappen(footerText);
    }
    getPlaceholderText(placeholderKeyText, placeholder) {
        return placeholderKeyText ? this.getPlaceholderKeyText(placeholderKeyText) : placeholder;
    }
    getPlaceholderKeyText(placeholderText) {
        if (!placeholderText)
            return null;
        switch (placeholderText) {
            case "welcomeTitle":
                return t("welcomeTitle", {
                    orgName: this.orgName,
                });
            case "welcomeText":
                return t("welcomeText", {
                    orgName: this.orgName,
                });
            case "dataUpdateWelcomeTitle":
                return t("dataUpdateWelcomeTitle", {
                    orgName: this.orgName,
                });
            case "dataUpdateWelcomeText":
                return t("dataUpdateWelcomeText", {
                    orgName: this.orgName,
                });
            case "purposeOfDataBriefEducation":
                return t("purposeOfDataBriefEducation", {
                    orgName: this.orgName,
                });
            case "patientFriendlyTitle":
                return t("patientFriendlyTitle", {
                    orgName: this.orgName,
                });
        }
        return willNeverHappen(placeholderText);
    }
    async handleMove(imageId, destinationPage, destinationSection, additionalSectionId) {
    }
    getSectionTitleLabel() {
        var _a, _b;
        return `Additional information section #${((_b = (_a = this.studyAdditionalSections) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + 1}`;
    }
    get addAdditionalSectionButtonLimitReachedDisabled() {
        var _a;
        return ((_a = this.formModel.input.additionalSections) !== null && _a !== void 0 ? _a : []).length >= maxStudyAdditionalSections;
    }
    isDuplicateContent(title) {
        return this.predefinedDisplayNames.includes(title);
    }
    deleteAdditionalSection(additionalSection) {
        var _a;
        const updatedSections = ((_a = this.formModel.input.additionalSections) !== null && _a !== void 0 ? _a : []).filter((section) => section.id !== additionalSection.id);
        this.formModel.input.additionalSections = updatedSections;
        this.formModel.updateInput({ additionalSections: this.formModel.input.additionalSections });
    }
    hasValidServerId(section) {
        return Boolean(section.id && !section.id.startsWith("temp_"));
    }
    getHealthRecordsUpdateFrequencyUnitText() {
        if (!this.formModel.input.healthRecordsUpdatesEnabled)
            return null;
        if (this.formModel.input.healthRecordsUpdatesEvery === undefined || this.formModel.input.healthRecordsUpdatesEvery === null)
            return null;
        if (this.formModel.input.healthRecordsUpdatesUnit === undefined || this.formModel.input.healthRecordsUpdatesUnit === null)
            return null;
        const frequency = Number(this.formModel.input.healthRecordsUpdatesEvery);
        switch (this.formModel.input.healthRecordsUpdatesUnit) {
            case StudyPeriodicDayAndWeekUnits.DAY:
                return t("daysWithCount", { count: frequency });
            case StudyPeriodicDayAndWeekUnits.WEEK:
                return t("weeksWithCount", { count: frequency });
        }
        return willNeverHappen(this.formModel.input.healthRecordsUpdatesUnit);
    }
}
__decorate([
    observable
], AddProjectViewModel.prototype, "addSectionTitle", void 0);
__decorate([
    computed
], AddProjectViewModel.prototype, "projectPages", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "study", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "studyAddedByOrganization", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "orgName", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "isSponsoredStudy", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "isInterventionalStudy", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "needsIdentifiedData", null);
__decorate([
    observable
], AddProjectViewModel.prototype, "protocolType", void 0);
__decorate([
    observable
], AddProjectViewModel.prototype, "protocolDocumentUrl", void 0);
__decorate([
    observable
], AddProjectViewModel.prototype, "studyToImport", void 0);
__decorate([
    computed
], AddProjectViewModel.prototype, "studyProtocolFileName", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "icfProtocolFileName", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "myStudyUser", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "currentPage", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "currentProjectPage", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "pageTitle", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "pageDescription", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "showBackButton", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "topBannerInfo", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "nextButtonText", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "nextButtonEnabled", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "showNextButton", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "showSkipButton", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "addProjectDialogTitleInfo", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "informedConsentLockedDialogModel", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "majorChangesDialogModel", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "majorChangesDialogTitle", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "majorChangesDialogText", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "studyId", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "orgId", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "studyAdditionalSections", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "studySectionImages", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "getSectionImages", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "getSectionImagesCount", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "getAdditionalSectionImages", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "getComponentKey", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "pdda", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "topBannerHeight", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "currentPageLoading", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "hasReachedMaxAdditionalSections", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "showShareButton", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "showDiscardChangesButton", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "saveAndExitButtonText", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "bottomPaddingForPage", null);
__decorate([
    computed
], AddProjectViewModel.prototype, "addAdditionalSectionButtonLimitReachedDisabled", null);
